// extracted by mini-css-extract-plugin
module.exports = {"p":"Faqsection_p__GqA_m","div":"Faqsection_div__1_axC"};